import { LayoutChangeEvent } from "react-native";

import { Button } from "@/components/Button";

export interface SuggestionProps {
  text: string;
  onPress?: () => void;
  disabled?: boolean;
  onLayout?: (e: LayoutChangeEvent) => void;
  mode?: string;
  visibility?: "visible" | "hidden";
}

export default function Suggestion({
  text,
  onLayout,
  onPress,
  disabled,
  mode,
  visibility = "visible",
}: SuggestionProps) {
  return (
    <Button
      style={{ visibility: visibility }}
      dataTrackingId="suggestion"
      mode={mode}
      borderBottomRightRadius={0}
      key={text}
      onLayout={onLayout}
      onPress={onPress}
      disabled={disabled}
      flexShrink={0}
      height="auto"
      paddingVertical="$75"
      textProps={{
        flexWrap: "wrap",
        whiteSpace: "normal",
        hyphens: "auto",
      }}
    >
      {text}
    </Button>
  );
}
